import { twMerge } from "tailwind-merge";
import { motion } from "motion/react";

export type Props = {
  children: React.ReactNode;
  className?: string;
  layout?: boolean;
};

export function MotionFade({ children, className, layout, ...props }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className={twMerge("", className)}
      layout={layout}
      {...props}
    >
      {children}
    </motion.div>
  );
}

export default MotionFade;
